module.exports = __webpack_public_path__ + "img/한국형1.f7ae198f.png";